import React, { createContext, useContext, useState, useEffect } from "react";
import { backendServerUrl } from "../config";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = not logged in
  
  // Check for existing token on app load
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const email = localStorage.getItem('authTokenEmail');
    
    if (token && email) {
      setUser({ email });
    }
  }, []);

  const login = async ({ email, password }) => {
    try {
      const response = await fetch(`${backendServerUrl}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const { token } = await response.json();
      localStorage.setItem('authToken', token); // Store token in localStorage
      localStorage.setItem("authTokenEmail", email); // Store email
      setUser({ email });
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const signup = async ({ email, password }) => {
    try {
      const response = await fetch(`${backendServerUrl}/api/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Registration failed');
      }

      const { message } = await response.json();
      alert(message); // Notify the user of successful registration
      return true;
    } catch (error) {
      console.error(error);
      alert(error.message);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken'); // Remove token on logout
    localStorage.removeItem("authTokenEmail"); // Remove email
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoggedIn: !!user,
        login,
        signup,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
